
interface User{
    fullname: string,
    username: string,
    email: string,
    phonenumber: string
    resetPasswordRequired: boolean
    languageCode: string
}

interface UserService{
    /**
     * Log in with specified username and password
     * Returns promise for user, rejects if bad username / password is provided
     * @param username
     * @param password
     */
    login(username: string, password: string):  ng.IPromise<User>
    /**
     * Log out from the authenticated user
     * Returns promise
     */
    logout(): ng.IPromise<any>
    /**
     * Get promise for current user, rejects if not logged in
     */
    get(): ng.IPromise<User>
}

class UserServiceImpl implements UserService{

    private User;
    private toastService;
    private $q: ng.IQService;
    public userDetails: any;

    constructor(User, toastService, $q){
        this.User = User;
        this.toastService = toastService;
        this.$q = $q;
        this.userDetails = this.User.getUser();
    }

    login(username:string, password:string):ng.IPromise<User> {

        var deferred = this.$q.defer();

        this.User.login({},{username: username, password: password}).$promise.then(
            (user) => {
                this.loggedIn(user);
                deferred.resolve(user);
            },
            (error) => {
                if(error && error.status === 401){
                    this.toastService.showSimpleToast('Feil brukernavn eller passord', 3000);
                }
                else{
                    this.toastService.parseError(error);
                }
                deferred.reject();
            }

        );
        return deferred.promise;
    }

    private loggedIn(user: User){
        this.userDetails = user;
    }

    logout():ng.IPromise<any> {
        var deferred = this.$q.defer();
        var clearAndResolve = ()=> {
            this.userDetails = null;
            deferred.resolve();
        };
        this.User.logout().$promise.then(
            () => clearAndResolve(),
            () => clearAndResolve() //If the user is already logged out the logout-function should still be resolved
        );
        return deferred.promise;
    }

    private reject(): ng.IPromise<any>{
        var deferred = this.$q.defer();
        deferred.reject();
        return deferred.promise;
    }

    get():ng.IPromise<User> {
        return this.userDetails
            ? this.userDetails.$promise
            : this.reject();
    }
}

rkcApp.service("userService",['User','toastService','$q',(User, toastService, $q) =>
    new UserServiceImpl(User, toastService, $q)]);


/** WEBPACK FOOTER **
 ** ./src/app/services/userService.ts
 **/